"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _shared = require("../../utils/shared.utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SIZES = {
  "default": {
    xs: {
      height: 8,
      width: 84
    },
    sm: {
      height: 11,
      width: 116
    },
    md: {
      height: 14,
      width: 147
    },
    lg: {
      height: 18,
      width: 189
    },
    xl: {
      height: 24,
      width: 252
    }
  },
  "short": {
    xs: {
      height: 10,
      width: 19
    },
    sm: {
      height: 14,
      width: 27
    },
    md: {
      height: 18,
      width: 34
    },
    lg: {
      height: 24,
      width: 45
    },
    xl: {
      height: 32,
      width: 60
    }
  }
};

/** @deprecated use HBLogo instead */
var HBNewLogo = function HBNewLogo(_ref) {
  var className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'xl' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _colors["default"].neutral900 : _ref$color,
    suffix = _ref.suffix;
  var maskId = (0, _react.useMemo)(function () {
    return (0, _shared.guid)();
  }, []);
  var selected = SIZES[type][size];
  return /*#__PURE__*/_react["default"].createElement(LogoSVG, (0, _extends2["default"])({}, selected, {
    className: className
  }), /*#__PURE__*/_react["default"].createElement(LogoMask, (0, _extends2["default"])({
    id: "fillMaskComponent-".concat(maskId)
  }, selected), /*#__PURE__*/_react["default"].createElement(LogoImage, (0, _extends2["default"])({
    href: "https://hbstatic.honeybook.com/assets_system/system_web/logos/new_logo".concat(type === 'short' ? '_short' : '').concat(suffix ? suffix : '', ".svg")
  }, selected))), /*#__PURE__*/_react["default"].createElement(LogoRect, (0, _extends2["default"])({
    fill: color,
    mask: "url(\"#fillMaskComponent-".concat(maskId, "\")")
  }, selected)));
};
var _default = exports["default"] = HBNewLogo;
var LogoSVG = _styledComponents["default"].svg.withConfig({
  displayName: "HBNewLogo__LogoSVG",
  componentId: "sc-1wfpjyu-0"
})(["display:block;height:", "px;width:", "px;"], function (props) {
  return props.height;
}, function (props) {
  return props.width;
});
var LogoMask = _styledComponents["default"].mask.withConfig({
  displayName: "HBNewLogo__LogoMask",
  componentId: "sc-1wfpjyu-1"
})(["height:", "px;width:", "px;"], function (props) {
  return props.height;
}, function (props) {
  return props.width;
});
var LogoImage = _styledComponents["default"].image.withConfig({
  displayName: "HBNewLogo__LogoImage",
  componentId: "sc-1wfpjyu-2"
})(["height:", "px;width:", "px;"], function (props) {
  return props.height;
}, function (props) {
  return props.width;
});
var LogoRect = _styledComponents["default"].rect.withConfig({
  displayName: "HBNewLogo__LogoRect",
  componentId: "sc-1wfpjyu-3"
})(["height:", "px;width:", "px;"], function (props) {
  return props.height;
}, function (props) {
  return props.width;
});
//# sourceMappingURL=HBNewLogo.js.map